import {useQuery} from '@apollo/client'
import {FormattedMessage, useIntl} from 'react-intl'
import {Spinner} from 'react-bootstrap'
import {GET_NOTES_POLICY} from '../../../gql/mutations/policyMutation'
import {IResNotePolicy} from '../../../types/policiesApi'
import {toast} from 'react-toastify'
import {useEffect, forwardRef, useImperativeHandle} from 'react'
import {ContentNotes} from './notes/ContentNotes'

interface LastNotePreviewProps {
  idPolicy: string
}

export const LastNotePreview = forwardRef(({idPolicy}: LastNotePreviewProps, ref) => {
  const intl = useIntl()
  const {data, loading, error, refetch} = useQuery<IResNotePolicy>(GET_NOTES_POLICY, {
    variables: {policyId: idPolicy},
    fetchPolicy: 'no-cache',
  })

  useImperativeHandle(ref, () => ({
    refetchNotes: () => refetch(),
  }))

  useEffect(() => {
    if (error)
      toast.error(
        intl.formatMessage(
          {id: 'policies.detail.notes.toast.errorLoading', defaultMessage: 'Error loading notes: {message}'},
          {message: error.message}
        )
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  if (loading) return <Spinner animation="border" size="sm" />
  if (!data || data.policyNotesByPolicy.length === 0) return null

  const lastNote = [...data.policyNotesByPolicy].sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
  )[0]

  return (
    <div className='list-menu '>
        <div className='kt-heading kt-heading--sm custom-border-brand my-3'>
          <FormattedMessage id='policies.detail.notes.lastNote' defaultMessage='Last Note' />
        </div>
        <ContentNotes notes={[lastNote]} compact={true} />
    </div>
  )
})